import React, { Component } from 'react';
import Select from 'components/shared/select';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';

class Workspace extends Component {
  state = {
    selectedId: this.props.workspaceId || '',
    loading: false,
  };

  static defaultProps = {
    workspaces: [],
    workspaceId: '',
  };

  handleWorkspaceChange = e => {
    const { contentId } = this.props;
    const { selectedId: prevSelectedId } = this.state;
    this.setState({ selectedId: e.target.value, loading: true }, () => {
      request
        .put(routes.LESSON(contentId), {
          lesson: { workspace_id: this.state.selectedId },
        })
        .then(() => this.setState({ loading: false }))
        .fail(() =>
          this.setState({ loading: false, selectedId: prevSelectedId }),
        );
    });
  };

  render() {
    const { workspaces } = this.props;
    const { selectedId, loading } = this.state;
    return (
      <div>
        <h3 className="Module-heading SectionHeading">
          {t('workspaces.workspace')}
        </h3>
        <div className="px-16">
          <Select
            disabled={loading}
            onChange={this.handleWorkspaceChange}
            value={selectedId}
            fullWidth
          >
            {workspaces.map(workspace => (
              <option key={workspace.id} value={workspace.id || ''}>
                {workspace.name}
              </option>
            ))}
          </Select>
        </div>
      </div>
    );
  }
}

export default Workspace;
